import React from 'react';
import { Mail } from 'lucide-react';
import { useLocalization } from '../../utils/hooks/useLocalization'
import { parseStringTags } from '../../utils/textUtils';
import styles from './AboutPage.module.css';

const AboutPage = ({ isMobile }) => {
  const { t, currentLanguage } = useLocalization();
  return (
    <>
      <section className={styles.about}>
        <div className={styles.backgroundText}>GLITCH</div>
        
        <div className={styles.container}>
            <h2 className={styles.title}>
              <span className={styles.titleMain}>OUR</span>
              <span className={styles.titleAccent}>VISION</span>
            </h2>
          
          <p className={styles.description}>
           {parseStringTags(t('about_description1'))}
          </p>

          
          <div className={isMobile ? styles.imageMobile : styles.image}>
            <img src={require('../../assets/dtune-story.jpg')} alt="dtune-story" />
          </div>

          <p className={styles.description}>
           {parseStringTags(t('about_description2'))}
          </p>

          
          <p className={styles.description}>
            {parseStringTags(t('about_description3'))}
          </p>

          
          <div className={styles.text}>
            <p>{t('about_footer')}</p>
          </div>

            
            
          <a className={styles.cardContainer} href={`/${currentLanguage}/discover`}>
            <div className={styles.card}>
              <Mail className={styles.icon3} size={48} />
              <h3 className={styles.cardTitle}>{t('about_contact_us_label')}</h3>
              <p className={styles.cardDescription}>{t('about_contact_us_description')}<br />
                <a href="mailto:info@dtune.it" style={{textDecoration: "underline", color: "var(--secondary)"}}>info@dtune.it</a>
              </p>
            </div>
          </a>
        </div>
      </section>
    </>
  );
};

export default AboutPage;

